import { optionsFlex_title } from './SettingsPane.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';

import { QuickOptions } from 'owa-options-view';
import { observer } from 'mobx-react-lite';

export default observer(function SettingsPane({ onDismiss }: HeaderPaneProps) {
    return (
        <HeaderFlexPane
            title={loc(optionsFlex_title)}
            content={<QuickOptions onDismiss={onDismiss} />}
            onDismiss={onDismiss}
        />
    );
});
